const translations = {
  "en": {
    "Continue": "Continue"
  },
  "zh-tw": {
    "Continue": "繼續"
  }
};

export default translations;
